module.exports = __webpack_public_path__ + "static/media/entregarinju6.41213acd.jpg";